import { useRef, useState, useCallback, useEffect } from "react";

interface AlphaSliderProps {
  alpha: number;
  color: string;
  onChange: (alpha: number) => void;
}

const AlphaSlider = ({ alpha, color, onChange }: AlphaSliderProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);

  const updatePosition = useCallback(
    (clientX: number) => {
      if (!containerRef.current) return;

      const rect = containerRef.current.getBoundingClientRect();
      const x = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      onChange(x);
    },
    [onChange]
  );

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true);
    updatePosition(e.clientX);
  };

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (isDragging) {
        updatePosition(e.clientX);
      }
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging, updatePosition]);

  return (
    <div
      ref={containerRef}
      className="slider-track alpha-slider"
      onMouseDown={handleMouseDown}
      style={{
        background: `
          linear-gradient(to right, transparent, ${color}),
          repeating-conic-gradient(#808080 0% 25%, #fff 0% 50%) 50% / 8px 8px
        `,
      }}
    >
      <div
        className="slider-thumb"
        style={{
          left: `${alpha * 100}%`,
          backgroundColor: "#ffffff",
        }}
      />
    </div>
  );
};

export default AlphaSlider;
